import { BaSeOptionPicker } from "@base/react"
import { optionsOrderBy } from "../../mocks/consts"
import { useEffect, useMemo, useRef, useState } from "react"
import "./index.scss"
import {eventTag} from "../../services/utils";

export default function PagePlanningsStructure ({
                                                  title = null,
                                                  button = null,
                                                  filters = null,
                                                  children,
                                                }) {
  return (
    <div className="page-plannings-structure">
      <div className="page-plannings-structure__header">
        {title && (
          <h2 className="page-plannings-structure__header-title">
            {title}
          </h2>
        )}

        {button}
      </div>

      {filters && (
        <div className="page-plannings-structure__filters">
          {filters}
        </div>
      )}

      <div className="page-plannings-structure__body">
        {children}
      </div>
    </div>
  )
}

export const TabsAndOrderBy = ({
                                 isDisabled,
                                 tabs = [
                                   {
                                     label: "Todos",
                                     count: "0",
                                     action: "all",
                                   },
                                   {
                                     label: "Em andamento",
                                     action: "progress",
                                   },
                                   {
                                     label: "Concluídos",
                                     action: "completed",
                                   },
                                 ],
                                 onFilter = null,
                                 forceChangeTab = null,
                                 event = {}
                               }) => {
  const [selectTab, setSelectTab] = useState("all")
  const [selectOrderId, setSelectOrderId] = useState(0)

  const lastFilterRef = useRef(null)

  const selectedOrder = useMemo(() => {
    return optionsOrderBy.find((item) => item.id === selectOrderId)?.order
  }, [selectOrderId])

  useEffect(() => {
    if (!onFilter) return

    const nextFilter = {
      tab: selectTab,
      orderBy: selectedOrder,
    }

    const lastFilter = lastFilterRef.current

    const isSameFilter =
      lastFilter?.tab === nextFilter.tab &&
      lastFilter?.orderBy === nextFilter.orderBy

    if (isSameFilter) return

    lastFilterRef.current = nextFilter

    onFilter(nextFilter)
  }, [selectTab, selectedOrder, onFilter])

  const changeTab = (tab) => {
    setSelectTab((prev) => {
      if (prev === tab) return prev
      return tab
    })
  }
  const handleOrderChange = (values) => {
    const nextOrderId = values?.[0]?.id ?? 0

    eventTag(
      event.name,
      event.category,
      "submit",
      `Filtro ordenar por: ${values?.[0]?.label}`
    )

    setSelectOrderId((prev) => {
      if (prev === nextOrderId) return prev
      return nextOrderId
    })
  }

  useEffect(() => {
    if (forceChangeTab) {
      setSelectTab(forceChangeTab)
    }

  }, [forceChangeTab]);

  return (
    <div className="page-plannings-structure__tabs">
      <div className="page-plannings-structure__tabs-buttons">
        {tabs.map((step, index) => (
          <button
            key={step.action || index}
            type="button"
            className={selectTab === step?.action ? "active" : ""}
            disabled={isDisabled}
            onClick={() => changeTab(step.action)}
          >
            {step.label} {!!step.count ? `(${step.count})` : ""}
          </button>
        ))}
      </div>

      <div className="page-plannings-structure__tabs-order-by">
        <p className="page-plannings-structure__tabs-order-by__label">
          Ordenar por
        </p>

        <div className="wrapper-select new-design">
          <BaSeOptionPicker
            values={optionsOrderBy}
            emptyValueLabel="Selecione"
            enableSelectAll={false}
            maxOptionsSelected={1}
            withFilterText={false}
            initialSelectedValuesId={[selectOrderId]}
            isDisabled={isDisabled}
            onChange={handleOrderChange}
          />
        </div>
      </div>
    </div>
  )
}